import React, { useState } from 'react';

const SESSION_KEY = 'lobees_docs_access';
const PASSWORD = process.env.REACT_APP_ACCESS_PASSWORD;

function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(() => {
    if (!PASSWORD) return true;
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  });
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  if (unlocked) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      setUnlocked(true);
    } else {
      setError(true);
      setInput('');
    }
  };

  return (
    <div style={styles.overlay}>
      <form onSubmit={handleSubmit} style={styles.card}>
        <h2 style={styles.title}>Lobees API Docs</h2>
        <p style={styles.subtitle}>Enter the access password to continue</p>
        <input
          type="password"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(false); }}
          placeholder="Password"
          autoFocus
          style={{ ...styles.input, ...(error ? styles.inputError : {}) }}
        />
        {error && <p style={styles.error}>Incorrect password</p>}
        <button type="submit" style={styles.button}>Access</button>
      </form>
    </div>
  );
}

const styles = {
  overlay: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0a0a0f',
  },
  card: {
    background: '#111118',
    border: '1px solid #2a2a3a',
    borderRadius: 12,
    padding: '40px 36px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    minWidth: 320,
  },
  title: {
    margin: 0,
    color: '#e8e8f0',
    fontFamily: 'Syne, sans-serif',
    fontSize: 22,
    fontWeight: 700,
  },
  subtitle: {
    margin: 0,
    color: '#888899',
    fontFamily: 'Syne, sans-serif',
    fontSize: 14,
  },
  input: {
    padding: '10px 14px',
    borderRadius: 8,
    border: '1px solid #2a2a3a',
    background: '#1a1a24',
    color: '#e8e8f0',
    fontSize: 15,
    outline: 'none',
    fontFamily: 'JetBrains Mono, monospace',
  },
  inputError: {
    border: '1px solid #ff6584',
  },
  error: {
    margin: 0,
    color: '#ff6584',
    fontSize: 13,
    fontFamily: 'Syne, sans-serif',
  },
  button: {
    marginTop: 4,
    padding: '10px 0',
    borderRadius: 8,
    border: 'none',
    background: '#6c63ff',
    color: '#fff',
    fontFamily: 'Syne, sans-serif',
    fontWeight: 600,
    fontSize: 15,
    cursor: 'pointer',
  },
};

export default PasswordGate;
